import React, { useEffect, useState } from 'react';
import { IconSpinner, NamedLink } from '../../../components';
import css from './InstagramFeed.module.css';
import InstagramFeedCard from './InstagramFeedCard/InstagramFeedCard';
import axios from 'axios';

function InstagramFeed({ winery, instafeed }) {
  const [feeds, setFeeds] = useState([]);
  const [feedsLoading, setFeedsLoading] = useState(false);
  const { accessToken, url } = instafeed;

  useEffect(() => {
    setFeedsLoading(true);
    axios
      .get(
        `https://graph.instagram.com/me/media?fields=id,media_type,media_url,caption&limit=${8}&access_token=${accessToken}`
      )
      .then(resp => {
        setFeeds(resp.data.data);
        setFeedsLoading(false);
      })
      .catch(err => {
        console.log('err', err);
        setFeedsLoading(false);
      });
  }, [instafeed]);

  // switch (media_type) { TODO:need work on media type comming from insta
  //   case "VIDEO":
  //       post = (
  //           <video
  //               width='100%'
  //               height='auto'
  //               src={media_url}
  //               type="video/mp4"
  //               controls playsinline>
  //           </video>
  //       )
  //       break;
  //   case "CAROUSEL_ALBUM":
  //       post = (
  //           <img
  //               width='100%'
  //               height='auto'
  //               id={id}
  //               src={media_url}
  //               alt={caption}
  //           />
  //       );
  //       break;
  //   default:
  //       post = (
  //           <img
  //               width='100%'
  //               height='auto'
  //               id={id}
  //               src={media_url}
  //               alt={caption}
  //           />
  //       );

  return (
    <div className={css.instagramFeedWrapper}>
      <div className={css.instagramFeedContainer}>
        <h1>Instagram Feed</h1>
        {feedsLoading ? (
          <div className={css.spinnerWrapper}>
            <IconSpinner />
          </div>
        ) : (
          <div className={css.instagramFeedCardWrapper}>
            {feeds?.map((feed, index) => (
              <InstagramFeedCard index={index} feed={feed} url={url} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default InstagramFeed;
